import { type AxiosInstance } from 'axios'

interface UpdateSubscriptionData {
  company: number
  subscription: number
  is_trial?: boolean
  trial_period_days?: number
  has_paid?: boolean
  expires_in?: string | null
  active?: boolean
}

export default (axios: AxiosInstance) => ({
  updateForCompany(subscriptionId: number, data: UpdateSubscriptionData) {
    return axios.put(`/v1/subscriptions/update/company_subscriptions/${subscriptionId}/`, data)
  },
})
